import { createReactLifecycles } from 'single-spa-workfront'
import NotificationCenter from './notification-center'
import { ErrorBoundary } from './utils/logger'

export { default as NotificationHub } from './notification-hub'

export const { bootstrap, mount, unmount } = createReactLifecycles({
  errorBoundary: ErrorBoundary,
  rootComponent: NotificationCenter,
})
